export default class AppNotificationHandler {
    isNotificationSupported;
    isPermissionGranted = false;
  
    constructor() {
      //浏览器是否支持Notification api
      const isNotificationSupported = 'Notification' in window;
      this.isNotificationSupported = isNotificationSupported;
      //用户是否同意接受通知
      if (isNotificationSupported) {
          this.isPermissionGranted = Notification.permission === 'granted';
      }
    }
  
    //请求开启系统通知功能
    async requestPermission() {
      const {isNotificationSupported} = this;
      if (!isNotificationSupported) {
        throw ('当前浏览器不支持 Notification API');
      }
      const permission = await Notification.requestPermission();
      if (permission  === 'granted') {
        this.isPermissionGranted = true;
      };
    }
  
    //打开系统通知功能（具体事件绑定由用户自定义）
    openNotification(title, options) {
      const {isNotificationSupported, isPermissionGranted} = this;
      if (!isNotificationSupported) {
        throw ('当前浏览器不支持Notification API');
      }
      if (!isPermissionGranted) {
        throw ('当前页面通知未开启');
      }
      return new Notification(title, options)
    }
  }
  